module.exports = __webpack_public_path__ + "monaco.svg?6bb3a6ad42a92768ac1a9222c8cbb519";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/monaco.svg
// module id = 234
// module chunks = 10